import styled from "styled-components";
import ModalFormRate from "../../../common/v2/ModalFormRate";

const DivMain = styled(ModalFormRate)`
  .divContentModal {
    z-index: 1500;
    max-width: ${({ stepSelected }) =>
      stepSelected === 2.5 ? "840px" : stepSelected === 3 ? "780px" : "700px"};
    max-height: ${({ stepSelected }) =>
      stepSelected === 2.5 ? "920px" : stepSelected === 3 ? "800px" : "775px"};
    overflow-y: ${({ stepSelected }) =>
      stepSelected === 2.5 ? "auto" : "initial"};
    padding: 12px 40px 10px 40px;
    background-color: ${({ stepSelected }) =>
      stepSelected === 4 ? "#000000" : "#ffffff"};
  }
`;

const PanelName = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  padding: 0 24px;
  .divCircleStep {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-family: "Roboto", Helvetica, sans-serif;
      font-weight: 700;
      font-size: 18px;
      line-height: 1.2;
      color: #ffffff;
      text-align: center;
    }
  }
  p {
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.2;
    color: #13131d;
    text-align: left;
  }
  input {
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #a9a9a9;
    background-color: #ffffff;
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 1.2;
    color: black;
    text-align: center;
    width: 90%;
    height: 50px;
  }
  input:focus {
    outline: none;
  }
  .buttonNext {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    items: center;
    justify-content: center;
    background-color: #f7af36;
    border-radius: 20px;
    border: none;
    padding: 0px 20px;
    cursor: pointer;

    p {
      font-family: "Roboto", Helvetica, sans-serif;
      font-weight: 700;
      font-size: 11px;
      line-height: 1.2;
      color: #ffffff;
      text-align: center;
    }
  }
`;
const PanelUbication = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  .divCircleStep {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-family: "Roboto", Helvetica, sans-serif;
      font-weight: 700;
      font-size: 18px;
      line-height: 1.2;
      color: #ffffff;
      text-align: center;
    }
  }
  p {
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.2;
    color: #13131d;
    text-align: left;
  }
  .inputUbication {
    padding: 10px;
    border-radius: 8px !important;
    border: 1px solid #525252;
    background-color: #ffffff;
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 400;
    font-size: 20px !important;
    line-height: 1.2;
    color: #13131d;
    text-align: center;
    width: 90%;
    height: 50px;
  }
  input:focus {
    outline: none;
  }
  .divButtons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    .buttonBack {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 20px;
      border: 1px solid #8f8f8f;
      padding: 0px 20px;
      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #8f8f8f;
        text-align: center;
      }
    }
    .buttonNext {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #f7af36;
      border-radius: 20px;
      border: none;
      padding: 0px 20px;
      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #ffffff;
        text-align: center;
      }
    }
  }
`;
const PanelUbicationMap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 1px;
  margin: 0px;
  .divUbicationMap {
    display: flex;
    flex-direction: column;
    position: relative;
    .divControl {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 6px;
      position: absolute;
      bottom: -20px;
      left: 10%;
      background-color: #000000;
      border-radius: 30px;
      padding: 5px 10px;
      z-index: 1000;
      width: 80%;
      .name {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #ffffff;
        flex: 1;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .btnUndo {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #3f3f3f;
        border-radius: 20px;
        border: none;
        padding: 7px 9px;
        cursor: pointer;
        flex-shrink: 0;
      }
      .btnClear {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #dc2626;
        border-radius: 20px;
        border: none;
        padding: 7px 9px;
        cursor: pointer;
        flex-shrink: 0;
      }
      .btnFinish {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background-color: #16a34a;
        border-radius: 20px;
        border: none;
        padding: 7px 12px;
        cursor: pointer;
        flex-shrink: 0;
        /* only the text label — NOT the icon span */
        span.label-text {
          font-family: "Roboto", Helvetica, sans-serif;
          font-size: 11px;
          font-weight: 700;
          color: white;
        }
      }
      .btnReset {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background-color: #dc2626;
        border-radius: 20px;
        border: none;
        padding: 7px 10px;
        cursor: pointer;
        flex-shrink: 0;
        span.label-text {
          font-family: "Roboto", Helvetica, sans-serif;
          font-size: 11px;
          font-weight: 700;
          color: white;
        }
      }
      .btnEdit {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f7af36;
        border-radius: 20px;
        border: none;
        padding: 7px 9px;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
  .headerDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    .divCircleStep {
      width: 50px;
      height: 50px;
      border-radius: 100%;
      background-color: #000000;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 1.2;
        color: #ffffff;
        text-align: center;
      }
    }
  }
  p {
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.2;
    color: #13131d;
    text-align: left;
  }
  input {
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #a9a9a9;
    background-color: #ffffff;
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 1.2;
    color: #13131d;
    text-align: center;
  }
  input:focus {
    outline: none;
  }
  .divButtons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    .buttonBack {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 20px;
      border: 1px solid #8f8f8f;
      padding: 0px 20px;
      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #8f8f8f;
        text-align: center;
      }
    }
    .buttonNext {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #f7af36;
      border-radius: 20px;
      border: none;
      padding: 0px 20px;
      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #ffffff;
        text-align: center;
      }
    }
  }
`;

const PanelInitialRate = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 5px;
  .divCircleStep {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-family: "Roboto", Helvetica, sans-serif;
      font-weight: 700;
      font-size: 18px;
      line-height: 1.2;
      color: #ffffff;
      text-align: center;
    }
  }
  .titleDiv {
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.2;
    color: #13131d;
    text-align: left;
  }
  .subtitleDiv {
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 400;
    font-size: 10px;
    line-height: 1.2;
    color: #8f8f8f8f;
    text-align: center;
    width: 55%;
  }
  .divBaseRate {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: flex-end;
    justify-content: center;
    width: 80%;
    .inputGroup {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .inputLabel {
        font-family: "Roboto", Helvetica, sans-serif;
        font-size: 11px;
        font-weight: 400;
        color: #8f8f8f;
        text-align: left;
      }
      .inputWithUnit {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
        span {
          font-family: "Roboto", Helvetica, sans-serif;
          font-size: 13px;
          font-weight: 400;
          color: #8f8f8f;
        }
        input {
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #a9a9a9;
          background-color: #ffffff;
          font-family: "Roboto", Helvetica, sans-serif;
          font-weight: 400;
          font-size: 18px;
          line-height: 1.2;
          color: #13131d;
          text-align: center;
          width: 90px;
          height: 46px;
        }
        input:focus {
          outline: none;
        }
      }
    }
  }
  .divButtons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    .buttonBack {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 20px;
      border: 1px solid #8f8f8f;
      padding: 0px 20px;
      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #8f8f8f;
        text-align: center;
      }
    }
    .buttonNext {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #f7af36;
      border-radius: 20px;
      border: none;
      padding: 0px 20px;

      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #ffffff;
        text-align: center;
      }
    }
  }
`;

const PanelRateDynamic = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  padding: 0 20px;
  .gridLayout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    width: 100%;
    align-items: start;
  }
  .sectionCard {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #f8f8f8;
    border-radius: 10px;
    padding: 14px;
  }
  .color-picker-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    position: relative;
  }
  .color-picker-wrapper {
    background-color: #e0e0e0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .color-picker-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  }
  .color-picker-label {
    font-family: "Roboto", Helvetica, sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #13131d;
  }
  .color-picker-modal {
    position: absolute;
    background-color: #1a1a1a;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    z-index: 100;
    gap: 6px;
    padding: 8px;
    border-radius: 8px;
    top: 40px;
    left: 0;
    width: max-content;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  .color-picker-option {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
  .color-picker-option:hover {
    transform: scale(1.15);
    transition: transform 0.1s;
  }
  .titleSection {
    font-family: "Roboto", Helvetica, sans-serif;
    font-size: 10px;
    font-weight: 700;
    color: #8f8f8f;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    width: 100%;
    margin-bottom: 2px;
  }
  .divBaseRate {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    .inputGroup {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .inputLabel {
        font-family: "Roboto", Helvetica, sans-serif;
        font-size: 11px;
        font-weight: 400;
        color: #8f8f8f;
        display: flex;
        align-items: center;
        gap: 3px;
      }
      .inputWithUnit {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
        span {
          font-family: "Roboto", Helvetica, sans-serif;
          font-size: 13px;
          font-weight: 400;
          color: #8f8f8f;
        }
        input {
          width: 90px;
          height: 44px;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #a9a9a9;
          background-color: #ffffff;
          font-family: "Roboto", Helvetica, sans-serif;
          font-weight: 400;
          font-size: 18px;
          text-align: center;
          color: #13131d;
        }
        input:focus {
          outline: none;
        }
      }
    }
  }
  .divColorPriority {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: flex-start;
    width: 100%;
    .divColorGroup,
    .divPriorityGroup {
      display: flex;
      flex-direction: column;
      gap: 6px;
      flex: 1;
      .inputLabel {
        font-family: "Roboto", Helvetica, sans-serif;
        font-size: 11px;
        font-weight: 400;
        color: #8f8f8f;
        display: flex;
        align-items: center;
        gap: 3px;
      }
      .divPrioritySelect {
        select {
          padding: 8px 10px;
          border-radius: 8px;
          border: 1px solid #a9a9a9;
          background: white;
          font-family: "Roboto", Helvetica, sans-serif;
          font-size: 13px;
          font-weight: 700;
          width: 180px;
          cursor: pointer;
        }
        select:focus {
          outline: none;
        }
      }
    }
  }
  .headerDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    width: 100%;
    gap: 10px;
    .divCircleStep {
      width: 30px;
      height: 30px;
      border-radius: 100%;
      background-color: #000000;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 1.2;
        color: #ffffff;
        text-align: center;
      }
    }
  }
  .priceKmDiv {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 2px;
    font-weight: 700;
    .divInputs {
      margin-left: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      input {
        width: 50px;
        padding: 10px;
        border-radius: 8px;
        background-color: #f1f1f1;
        border: none;
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 400;
        font-size: 13px;
        line-height: 1.2;
        color: #13131d;
        text-align: center;
      }
      input:focus {
        outline: none;
      }
    }
  }
  .divOnDemand {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    .divInputs {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      input {
        padding: 10px;
        width: 100px;
        border-radius: 8px;
        border: none;
        background-color: #f1f1f1;
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 400;
        font-size: 13px;
        line-height: 1.2;
        color: #13131d;
        text-align: center;
      }
      input:focus {
        outline: none;
      }
    }
  }
  hr {
    width: 100%;
    height: 1px;
    background-color: #e0dede;
    border: none;
    margin: 20px 0px;
    border-radius: 8px;
    opacity: 0.5;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  }
  .divSchedule {
    display: flex;
    flex-direction: row;
    gap: 30px;

    font-weight: 700;
    justify-content: center;
    align-items: center;
    .divInputs {
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
      justify-content: center;
      input {
        width: 50px;
        padding: 10px;
        border-radius: 8px;
        border: none;
        background-color: #f1f1f1;
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 13px;
        line-height: 1.2;
        color: #13131d;
        text-align: center;
      }
      select {
        width: 60px;
        padding: 10px;
        border-radius: 8px;
        border: none;
        background-color: #f1f1f1;
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 400;
        font-size: 13px;
        line-height: 1.2;
        color: #13131d;
        text-align: center;
        font-weight: 700;
      }
      input,
      select:focus {
        outline: none;
      }
    }
  }
  .divButtons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: center;
    .buttonBack {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #ffffff;
      border: 1px solid #8f8f8f;

      border-radius: 20px;
      padding: 0px 20px;

      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #8f8f8f;
        text-align: center;
      }
    }
    .buttonNext {
      display: flex;
      flex-direction: row;
      items: center;
      justify-content: center;
      background-color: #f7af36;
      border-radius: 20px;
      border: none;
      padding: 0px 20px;
      cursor: pointer;

      p {
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 700;
        font-size: 11px;
        line-height: 1.2;
        color: #ffffff;
        text-align: center;
      }
    }
  }
`;

const PanelFinish = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  h3 {
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 700;
    font-size: 25px;
    width: 300px;
    line-height: 1.2;
    color: #ffffff;
    text-align: center;
  }
  .divSubtitle {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 300px;
    p {
      font-family: "Roboto", Helvetica, sans-serif;
      font-weight: 400;
      font-size: 12px;
      line-height: 1.2;
      color: #8f8f8f8f;
      text-align: left;
    }
  }
  .btnEnd {
    display: flex;
    flex-direction: row;
    items: center;
    justify-content: center;
    background-color: #f7af36;
    border-radius: 20px;
    border: none;
    padding: 0px 20px;
    width: 140px;
    cursor: pointer;

    p {
      font-family: "Roboto", Helvetica, sans-serif;
      font-weight: 700;
      font-size: 11px;
      line-height: 1.2;
      color: #ffffff;
      text-align: center;
    }
  }
`;

export default {
  DivMain,
  PanelName,
  PanelUbication,
  PanelUbicationMap,
  PanelInitialRate,
  PanelRateDynamic,
  PanelFinish,
};
